<template>
	<v-card outlined>
		<v-card-title
			v-text = "'Connections'" 
			class  = "justify-center text-uppercase caption pa-1 light-blue darken-2 white--text"
		></v-card-title>
		<v-card-text>
			
		
			<v-row>
				<v-col 
					v-for = "(item,key,index) of connections"
					:key  = "index"
					:md   = "key == 'location_host' ? 4 : 4"
				
				>
					<v-card outlined>							
						<v-card-text class = "pa-1 ma-0">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }"> 										
									<v-switch small 
										v-if="key=='debug'"
										v-on="on"  
										v-model="connections[key]" 
										label="Debug"
										class="pa-1 ma-0"
										hide-details
										
									></v-switch>
								</template>
								<span class="caption">									
									Activate this option to debug the page you are on
								</span>
							</v-tooltip>
					
						<v-text-field
							v-if="key!=='debug' &&  typeof item ==='number'"
							outlined
							dense
							hide-details
							v-model.number="connections[key]"
							:label="$ml.get(key)"
							:disabled="key=='location_ip_port' ? true : true"
						></v-text-field>
						<v-text-field
							v-if="key!=='debug' &&  typeof item ==='string'"
							outlined
							dense
							hide-details
							v-model="connections[key]"
							:label="$ml.get(key)"
							:disabled="true"
						></v-text-field>
						<!-- 	placeholder="Example: 9090" -->
						<v-select
							v-if="typeof item==='object'"
							outlined
							:label="$ml.get(key)"
							:items="item"
							hide-details
							dense
						></v-select>
						</v-card-text>
					</v-card>
					</v-col>
					<v-divider></v-divider>
 				<!-- <v-col md="12" sm="12">
 					<v-card outlined>
 					<v-data-table
 						dense
 						outlined
 						:headers="header"
 						:items="info_routes"

 					></v-data-table>
 					</v-card>
 				</v-col> -->
			</v-row>
		</v-card-text>
	</v-card> <!-- Connections -->
</template>
<script>
	export default{
		name: 'connection_parameters',
		props: [ 'info_component' ],
		data: (vm) => ({
			connnections_fields : [

			],
			connections:{
				// type: 'http',
				protocol 		: 'http://',
				ip 				: 'localhost',
				port 			: '8000',
				protocol_socket : 'http://',
				ip_socket 		: 'localhost',
				port_socket 	: '4550',
				port_face		: '8004',
				// location_ip_port: 0,
				// protocols: ['http://', 'ws://'],
				// location_ip: '',
				// axios_protocol: 'http://',
				// axios_port: 9090,
				// list_sockets: [],
				// listen_sockets:[],	
				// names_ws: [],
				// alias_port_ws: ''
				// debug: false,
				// socket_tables: []
			}, 
		}), //data
		mounted(){				
			this.connections.ip 				= this.$localhost 		;//|| location.hostname;
			this.connections.port 				= this.$port 	  		;//|| parseInt(location.port);
			this.connections.protocol 			= this.$protocol   		;
			this.connections.protocol_socket	= this.$protocol_socket ;
			this.connections.ip_socket 			= this.$localsocket 	;
			this.connections.port_socket 		= this.$port_socket 	;
			this.connections.port_face 			= this.$port_face 	;

		}

	};
</script>